import { xorCrypt } from './utils/xorCrypt.js';
import { debug } from './utils/debug.js';
import { isValid } from './validateSid.js';

/**
 * Decodes encoded SID.
 * @param {String} sznclid - Value of "sznclid" UTM parameter.
 */
const decodeClid = (sznclid) => {
  const count = Math.ceil(sznclid.length / 4) * 4;
  const padded = sznclid.padEnd(count, '=');
  try {
    const decoded = atob(padded.replace(/_/g, '/').replace(/-/g, '+'));

    // first char is key use it in xorCrypt
    const sid = xorCrypt(decoded.substring(1), decoded.charCodeAt(0));

    if (isValid(sid)) {
      // got valid sid - return it
      return sid;
    }

    // did not get valid sid
    debug('warn', `"decodeClid" - SID ${sznclid} did not pass validation, returning null`);
    return null;
  } catch (e) {
    debug('error', `"decodeClid" - SID ${sznclid} threw error during validation. ${e}`);
    return null;
  }
};

export { decodeClid };
